import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/main.css'

// App erstellen
const app = createApp(App)

// Pinia Store
const pinia = createPinia()
app.use(pinia)

// Router
app.use(router)

// Globalen Error Handler registrieren
app.config.errorHandler = (err: unknown, instance: any, info: string) => {
  console.error('Globaler Fehler:', err)
  console.error('Component:', instance)
  console.error('Info:', info)
}

// App mounten
app.mount('#app')

// Service Worker: hält die App-Dateien für den Offline-Übungsbereich vor (nur im Produktivbetrieb - im
// Entwicklungsmodus würde er Vite-Dateien festhalten)
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => console.warn('Service Worker nicht registriert:', err))
  })

  // Den Offline-Übungsbereich schon online laden, damit sein Programmteil im Cache liegt, wenn das Netz weg ist
  const warmOfflineArea = () => void import('@/modules/practice/views/OfflinePracticeView.vue').catch(() => {})
  if (localStorage.getItem('studiopro_token')) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(warmOfflineArea, { timeout: 10000 })
    else setTimeout(warmOfflineArea, 5000)
  }
}
